import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import MicrosoftLogin from 'react-microsoft-login';
import Box from '@mui/joy/Box';
import Grid from '@mui/joy/Grid';
import { Button } from '@mui/joy';
import { useAppDispatch } from '../app/hooks';
import { fetchMe, setToken } from '../features/me/me';

const Login = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [foo, setCookie] = useCookies(['jolly']);
  console.log(foo);

  return (
    <div style={{ flexGrow: '1' }}>
      <Box flex={1} sx={{ width: '100%' }}>
        <Grid
          container
          direction="column"
          padding="50px"
          justifyContent="flex-start"
          alignItems="center"
          textAlign="center"
          spacing={1}
        >
          <Grid xs={6}>
            <img width={128} src="logo.png" alt="logo" />
          </Grid>
          <Grid xs={6}>
            <h2>DGtek CGNAT Log Search</h2>
          </Grid>
          <Grid xs={6} alignContent="center" />
          <Grid xs={8} alignContent="center">
            <MicrosoftLogin
              className="App"
              clientId="35c218ef-227d-40fe-aac6-70ff4e50191c"
              buttonTheme="dark"
              tenantUrl="https://login.microsoftonline.com/dgtek.net"
              authCallback={(err, data) => {
                console.log('DATA', data.idToken);
                console.log('ERR', err);
                dispatch(setToken(data.idToken));
                dispatch(fetchMe(data.idToken));
                setCookie('jolly', data.idToken, {
                  path: '/',
                  secure: true,
                  sameSite: 'none',
                });
                navigate('/');
              }}
            >
              <Button>Login</Button>
            </MicrosoftLogin>
          </Grid>
          <Grid xs={6}>2023 © DGtek Pty. Ltd. ABN 61 600 896 115</Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Login;
